import { Component, ChangeDetectionStrategy } from '@angular/core';

import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'luna-carousel',
	imports: [NgbCarouselModule],

	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './carousel.component.html',
})
export class LunaCarousel {
	heroImages = [
		'../../assets/images/carousel/Hero_Image_1.png',
		'../../assets/images/carousel/Hero_Image_2.png',
		'../../assets/images/carousel/Hero_Image_3.png',
	]
}
